import { createI18n } from 'vue-i18n'
import useLanguage from './hooks/useLanguage'

const modules = import.meta.glob('./locales/**/*.json', { eager: true })

const lang = {
  'CN,zh-Hans': {},
  'US,en': {}
}

Object.entries(modules).forEach(([path, module]: [string, any]) => {
  const messages = module.default
  if (path.endsWith('zh.json')) {
    Object.assign(lang['CN,zh-Hans'], messages)
  } else if (path.endsWith('en.json')) {
    Object.assign(lang['US,en'], messages)
  }
})
// TODO: 通过IP获取locale初始态并set到localStorage
const locale = useLanguage().locale
const isEnglish = useLanguage().isEnglish
localStorage.setItem('locale', locale)
document.querySelector('body')?.classList.add(isEnglish ? 'en' : 'cn')
window.chinese = () => {
  localStorage.setItem('locale', 'CN,zh-Hans')
  location.reload()
}
window.english = () => {
  localStorage.setItem('locale', 'US,en')
  location.reload()
}
const i18n = createI18n({
  locale: locale,
  fallbackLocale: locale,
  messages: lang,
  legacy: false, // 如果要支持composition-api，需要设置为false
  globalInjection: true
})
export default i18n
